module.exports = __webpack_public_path__ + "img/like.171e914f.svg";